import React from 'react'
import DownLoad from './DownLoad'
import Purchase from './Purchase'
import Form from './Form'
import Outlink from './Outlink'

const ConversionModule = ({ className, extensionType, extention }) => {
  const ConversionComponentMap = {
    0: DownLoad,
    1: Purchase,
    2: Form,
    3: Outlink,
  }
  const ConversionComponent = ConversionComponentMap[extensionType]

  return ConversionComponent ? (
    <div className={className}>
      <ConversionComponent {...extention} />
    </div>
  ) : null
}

export default ConversionModule



// WEBPACK FOOTER //
// ./src/modules/Conversion/index.js